import React from 'react';
import PropTypes from 'prop-types';

const MIME_TYPES = {
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg',
  wav: 'audio/wav',
};

const extractExtension = (value = '') => {
  if (!value) {
    return '';
  }

  const normalized = value.toLowerCase();
  const match = normalized.match(/\.([a-z0-9]+)(?:$|[?#])/);
  return match ? match[1] : '';
};

const resolveMimeType = (src, filename) => {
  const extension = extractExtension(filename) || extractExtension(src);
  return MIME_TYPES[extension] || 'audio/mpeg';
};

const AudioMessage = ({ src, fallbackUrl, filename }) => {
  const resolvedSrc = src || fallbackUrl;

  if (!resolvedSrc) {
    return null;
  }

  const mimeType = resolveMimeType(resolvedSrc, filename);

  return (
    <div className="audio-message">
      <audio controls preload="none">
        <track kind="captions" />
        <source src={resolvedSrc} type={mimeType} />
        Your browser does not support the audio element.
        {' '}
        {fallbackUrl && (
          <a href={fallbackUrl} target="_blank" rel="noopener noreferrer">
            Download audio
          </a>
        )}
      </audio>
    </div>
  );
};

AudioMessage.defaultProps = {
  fallbackUrl: '',
  filename: '',
};

AudioMessage.propTypes = {
  src: PropTypes.string.isRequired,
  fallbackUrl: PropTypes.string,
  filename: PropTypes.string,
};

export default AudioMessage;
